import {
  type SessionIngestionSummary,
  type SessionRecord,
  tracksCompletion,
} from "@/shared/domain/sessions";

import { ingestionBadgeFor, type SessionBadge } from "./sessionIngestionBadge";

/** Whether a list row shows the session as complete, and its ingestion badge. */
export interface SessionListStatus {
  complete: boolean;
  ingestion: SessionBadge | null;
}

/**
 * What a list row's Status cell shows for the session: the same badges as its
 * page. Null for a session nobody opted into completion (see
 * {@link tracksCompletion}).
 */
export function sessionListStatus(
  session: Pick<SessionRecord, "status" | "completed_at" | "completion_policy">,
  summary: SessionIngestionSummary | undefined,
  summaries: { failed: boolean },
): SessionListStatus | null {
  if (!tracksCompletion(session)) {
    return null;
  }
  // The summary is fetched after the row and refetched, so it decides when
  // there is one: a session that completed itself, or was put back in
  // progress, since the row was read shows as it is now.
  const complete =
    summary === undefined
      ? session.status === "complete"
      : summary.state !== "in_progress";
  return {
    complete,
    ingestion: ingestionBadgeFor(complete, summary, summaries),
  };
}
